import {
  SET_TOKEN,
  SET_USER_INFORMATION,
  SET_USER_LANGUAGE,
  USER_LANGUAGE_OPTIONS,
  OPEN_ICIVET_AUTHORIZE_DIALOG,
  SET_WEBSITE_LIST,
  WEBSITE_SELECTED,
  SET_WEBSITE_NAVIGATIONS, GLOBAL_CATALOGS, GLOBAL_KEY, FULL_PROFILE,
  FULL_DASHBOARD,
  USER_AREA_LANGUAGES_OPTIONS,
} from '../types';

const initialState = {
    defaultArea: {},  // 默認站點
    areas: [], // 站點列表
    profile: null,
    worker: null,
    lng: null,
    areaOptions: [],
    lngOptions: [], // 
    today_visitor_number: 0,
    total_readers_number: 0,
    openIcivetAuthorize: false,

    // 我的回應
    user_reply: {
      list: [],
      total: 0,
      page: 1,
      rowsPerPage: 10,
      pages: 10,
    },
    // 我的報修
    user_repair: {
      list: [],
      total: 0,
      page: 1,
      rowsPerPage: 10,
      pages: 10,
    },

    website: {
      selected: {},
      list: []
    },

    // 導航欄
    navigations: [], 

    // 首頁數據 start
    banners: [],
    recommend: [],
    latestNews: {
      value: '',
      tabs: [],
      list: []
    },
    serviceSector: {
      tickets: {},
      list: [],
    },
    serviceApplications: [],
    quickConnections: [],
    // 首頁數據 end

    global: [],
  };

  const userReducer = function (state = initialState, action) {
    switch (action.type) {
      case OPEN_ICIVET_AUTHORIZE_DIALOG: {
        return {
          ...state,
          openIcivetAuthorize: action.payload
        };
      }
      case SET_USER_INFORMATION: {
        return {
          ...state,
          ...action.payload,
        };
      }
      case SET_TOKEN: {
        return {
          ...state,
          token: action.payload
        };
      }
      case SET_USER_LANGUAGE: {
        return {
          ...state,
          lng: action.payload
        };
      }
      case USER_AREA_LANGUAGES_OPTIONS: {
        return {
          ...state,
          areaOptions: action.payload
        };
      }
      case USER_LANGUAGE_OPTIONS: {
        return {
          ...state,
          lngOptions: action.payload
        };
      }

      case GLOBAL_KEY: {
        return {
          ...state,
          global: action.payload
        };
      }

      // 服務
      case GLOBAL_CATALOGS.Service.Root: {
        return {
          ...state,
          serviceSector: action.payload
        };
      }

      /*  登錄後加載的首頁數據 dashboard data */
      case GLOBAL_CATALOGS.Banner: {
        return {
          ...state,
          banners: action.payload
        };
      }
      case GLOBAL_CATALOGS.Recommend: {
        return {
          ...state,
          recommend: action.payload
        };
      }
      // 首頁最新消息[全部]選項數據
      case FULL_DASHBOARD.News.List: {
        return {
          ...state,
          latestNews: {
            ...state.latestNews,
            list: action.payload
          }
        };
      }
      case FULL_DASHBOARD.News.Tabs: {
        return {
          ...state,
          latestNews: {
            ...state.latestNews,
            tabs: action.payload
          }
        };
      }
      case FULL_DASHBOARD.News.Value: {
        return {
          ...state,
          latestNews: {
            ...state.latestNews,
            value: action.payload
          }
        };
      }
      
      // 服務應用
      case GLOBAL_CATALOGS.ServiceApplication: {
        return {
          ...state,
          serviceApplications: action.payload
        };
      }
      // 友善連結
      case GLOBAL_CATALOGS.Link: {
        return {
          ...state,
          quickConnections: action.payload
        };
      }
      // 頁腳服務
      case GLOBAL_CATALOGS.FooterLink: {
        return {
          ...state,
          footerLinks: action.payload
        };
      }

      /* 登錄後加載的首頁數據 dashboard data */
      //  站點列表
      case SET_WEBSITE_LIST: {
        return {
          ...state,
          website: { list: action.payload }
        };
      }
      // 當前站點
      case WEBSITE_SELECTED: {
        return {
          ...state,
          website: { ...state?.website, selected: action.payload }
        };
      }
      // 站點導航欄
      case SET_WEBSITE_NAVIGATIONS: {
        return {
          ...state,
          navigations: action.payload
        };
      }
      // 我的回應列表
      case FULL_PROFILE.Reply.List: {
        return {
          ...state,
          user_reply: { ...action.payload }
        };
      }
      // 我的報修列表
      case FULL_PROFILE.Repair.List: {
        return {
          ...state,
          user_repair: { ...action.payload }
        };
      }

      default: {
        return state;
      }
    }
  };

  export default userReducer;
